export default __webpack_public_path__ + "static/media/hive_hive.c823251c.svg";